import React from 'react';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import { makeStyles } from '@material-ui/core';
import AttachIcon from '@material-ui/icons/AttachFile';

import { FileFullResponse, FormComponent } from '#web-components/components/Form/types';
import { ColumnDefinition, ListItem } from '#web-components/types/table';
import InlineButton from '#web-components/components/InlineButton';
import Typography from '#web-components/components/Typography';
import { getFileName } from '#web-components/components/Form/utils';

import styles from './FileCell.styles';

interface FileCellProps {
  component: FormComponent;
  item: ListItem;
  columnDefinition: ColumnDefinition;
}

const useStyles = makeStyles(styles, { name: 'FileCell' });

export const FileCell: React.FC<FileCellProps> = ({ columnDefinition, component, item }: FileCellProps) => {
  const classes = useStyles();
  const value: Array<FileFullResponse> = get(item, columnDefinition.property, []);
  const valueArray = isArray(value) ? value : [];

  if (get(component, 'uploadOnly', false)) {
    return (
      <span>{valueArray.map((file) => file.name).join(', ')}</span>
    );
  }

  return (
    <>
      {valueArray.map((file) => (
        <div className={classes.linkContainer} key={file.url}>
          <InlineButton
            download={getFileName(file)}
            to={file.url}
            classes={{ link: classes.link }}
            leftIcon={<AttachIcon className={classes.icon} />}
          >
            <Typography variant="accentTiny" component="span" className={classes.text}>
              {getFileName(file)}
            </Typography>
          </InlineButton>
        </div>
      ))}
    </>
  );
};
